var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9C4.725 9 4.48958 8.90208 4.29375 8.70625C4.09792 8.51042 4 8.275 4 8V2C4 1.725 4.09792 1.48958 4.29375 1.29375C4.48958 1.09792 4.725 1 5 1H9.5C9.775 1 10.0104 1.09792 10.2063 1.29375C10.4021 1.48958 10.5 1.725 10.5 2V8C10.5 8.275 10.4021 8.51042 10.2063 8.70625C10.0104 8.90208 9.775 9 9.5 9H5ZM5 8H9.5V2H5V8ZM3 11C2.725 11 2.48958 10.9021 2.29375 10.7063C2.09792 10.5104 2 10.275 2 10V3.5C2 3.35833 2.04792 3.23958 2.14375 3.14375C2.23958 3.04792 2.35833 3 2.5 3C2.64167 3 2.76042 3.04792 2.85625 3.14375C2.95208 3.23958 3 3.35833 3 3.5V10H8C8.14167 10 8.26042 10.0479 8.35625 10.1438C8.45208 10.2396 8.5 10.3583 8.5 10.5C8.5 10.6417 8.45208 10.7604 8.35625 10.8562C8.26042 10.9521 8.14167 11 8 11H3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyS);
export default __webpack_public_path__ + "static/media/copy-s.523ce16ebdbaa4fbd7685a065172ee3d.svg";
export { ForwardRef as ReactComponent };